/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import HeroService from 'parts/HeroService';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import AllService from 'parts/AllService';

import { Services } from 'json/landingPageData';

export default class ServicePage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <HeroService />
        <AllService data={Services} />
        <Discuss />
        <Footer />
      </>
    );
  }
}
